module.exports = __webpack_public_path__ + "img/sartan_no.305b625d.png";